<!-- 旧件回收订单详情页 -->
<template>
  <div class="app-container order-detail-wrap">
    <div class="module-wrap">
      <el-descriptions title="基础信息" :column="4">
        <el-descriptions-item label="订单编号">
          {{ formData.recycleNo || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="订单状态">
          {{ formData.recycleStatusStr || '--' }}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="仓库编号">
					{{ formData.stationId || '--' }}
				</el-descriptions-item>
        <el-descriptions-item label="仓库名称">
					{{ formData.stationName || '--' }}
				</el-descriptions-item> -->
        <el-descriptions-item label="下单旧机">
          {{ formData.orderCount || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="承运商">
          {{ formData.carrierName || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="承运商组织">
          {{ formData.carrierOrg || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ formData.createdDate || '--' }}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="回收地址">
					{{ completeAddress || '--' }}
				</el-descriptions-item>
				<el-descriptions-item label="联系人">
					{{ formData.contactName || '--' }}
				</el-descriptions-item>
				<el-descriptions-item label="联系电话">
					{{ formData.contactMobile || '--' }}
				</el-descriptions-item> -->
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="派工信息" :column="4">
        <el-descriptions-item label="回收人员姓名">
          {{ formData.recoveryWorkerName || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="回收人员电话">
          {{ formData.recoveryWorkerPhone || '--' }}
          <span v-if="formData.recoveryWorkerPhone">
            <img v-if="!dataVisible.recoveryWorkerPhone" src="@/assets/eye-close.png" @click="toggleVisibility('recoveryWorkerPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('recoveryWorkerPhone')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="取货车牌号">
          {{ formData.vehicleLicenseNo || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="预约时间">
          {{ transDateTimeStrFun() }}
        </el-descriptions-item>
        <el-descriptions-item label="派工时间">
          {{ formData.dispatchDate || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="完成预约时间">
          {{ formData.completedAppointDate || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="完成时间">
          {{ formData.completedDate || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="异常信息反馈">{{ formData.feedback || '--' }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="回收信息" :column="4">
        <el-descriptions-item label="签到时间">
          {{ formData.signInDate || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="签到地址">
          {{ formData.signInAddress || '--' }}
          <span v-if="formData.signInAddress">
            <img v-if="!dataVisible.signInAddress" src="@/assets/eye-close.png" @click="toggleVisibility('signInAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('signInAddress')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="实收旧机">
          {{ formData.actualCount || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ formData.remark || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="交割单照片" :span="5">
          <template v-if="formData.waybillPhotoList.length > 0">
            <div class="img-flex">
              <div v-for="(item, index) in formData.waybillPhotoList" :key="index">
                <div class="downLoadLink" v-if="isPDF(item.annexId)" @click="downLoadPdf(item.annexId)">
                  {{ item.annexId }}
                </div>
                <image-upload v-else :imageUrl.sync="item.annexId" :editMode="false" @success="uploadSuccess($event, item, 'waybillPhotoList')" />
              </div>
            </div>
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="装车照片" :span="5">
          <template v-if="formData.cargoLoadingPhotoList.length > 0">
            <div class="img-flex">
              <div v-for="(item, index) in formData.cargoLoadingPhotoList" :key="index">
                <div class="downLoadLink" v-if="isPDF(item.annexId)" @click="downLoadPdf(item.annexId)">
                  {{ item.annexId }}
                </div>
                <image-upload v-else :imageUrl.sync="item.annexId" :editMode="true" @success="uploadSuccess($event, item, 'cargoLoadingPhotoList')" />
              </div>
            </div>
          </template>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div>
      <div class="tit-name">网点明细</div>
      <div>
        <el-table :data="stationDtoList">
          <el-table-column prop="stationId" label="网点编号" min-width="140"></el-table-column>
          <el-table-column prop="stationName" label="网点名称" min-width="150"></el-table-column>
          <el-table-column prop="recycleCount" label="旧机数量" min-width="120"></el-table-column>
          <el-table-column prop="contactName" label="联系人" min-width="140"></el-table-column>
          <el-table-column prop="contactMobile" label="联系电话" min-width="140">
            <template slot-scope="scope">
              {{ scope.row.contactMobile }}
              <span v-if="scope.row.contactMobile">
                <img v-if="!scope.row._contactMobileVisible" src="@/assets/eye-close.png" @click="toggleRowVisibility(scope.row, 'contactMobile')" />
                <img v-else src="@/assets/eye-open.png" @click="toggleRowVisibility(scope.row, 'contactMobile')" />
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="网点地址" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.address }}
              <span v-if="scope.row.address">
                <img v-if="!scope.row._addressVisible" src="@/assets/eye-close.png" @click="toggleRowVisibility(scope.row, 'address')" />
                <img v-else src="@/assets/eye-open.png" @click="toggleRowVisibility(scope.row, 'address')" />
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div>
      <div class="tit-name">回收明细</div>
      <div>
        <el-table :data="recycleTableData">
          <el-table-column type="action" label="操作" width="120">
            <template slot-scope="scope">
              <el-row>
                <el-link type="primary" @click="rowDetailFun(scope.row)">详情</el-link>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" label="京东工单号" width="160"></el-table-column>
          <el-table-column prop="oldBarCode1" label="条码1" width="150"></el-table-column>
          <el-table-column prop="oldBarCode2" width="160" label="条码2"></el-table-column>
          <el-table-column type="thirdOldCate" label="京东旧机品类" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.thirdOldCate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jdSize" label="京东旧机规格" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.fourthOldCate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jdOldCateroy" label="鉴定旧机品类" width="150">
            <template slot-scope="scope">
              <span>{{ oldCatoeryStrFun(scope.row, 'category') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jdOldSize" width="160" label="鉴定旧机规格">
            <template slot-scope="scope">
              <span>{{ oldCatoeryStrFun(scope.row, 'specification') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="consistent" label="是否一致" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.consistent == 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="complete" width="160" label="是否完整">
            <template slot-scope="scope">
              <span>{{ scope.row.complete == 1 ? '是' : '否' }}</span>
            </template> </el-table-column
          >*
        </el-table>
      </div>
    </div>

    <div class="footer-wrap">
      <div class="foot-weight">铜管重量：{{ formData.copperTubeWeight }}</div>
      <div class="foot-weight">缺失连接管数：{{ formData.connectingPipeCount || '-' }}</div>
      <div class="foot-weight">铝管数：{{ formData.aluminumTubeCount || '-' }}</div>
      <div class="foot-weight">铜管少于3米数：{{ formData.copperPipeThreeCount || '-' }}</div>

    </div>
    <OldMachineDetDialog ref="oldMachineDetDialogRef"></OldMachineDetDialog>
  </div>
</template>
<script>
import OldMachineDetDialog from './components/OldMachineDetDialog.vue'
import imageUpload from '@/components/Upload/ImageUpload'
export default {
  components: {
    OldMachineDetDialog,
    imageUpload
  },
  data() {
    return {
      formData: {
        waybillPhotoList: [],
        cargoLoadingPhotoList: []
      },
      recycleTableData: [],
      stationDtoList: [],
      originData: {},
      originStationDtoList: [],
      dataVisible: {
        signInAddress: false,
        recoveryWorkerPhone: false,
        stationDtoContactMobile: false,
        stationDtoAddress: false
      },
      signInAddress: '',
      recoveryWorkerPhone: '',
      stationDtoContactMobile: '',
      stationDtoAddress: ''
    }
  },
  computed: {
    // 回收地址
    completeAddress() {
      const { province, city, county, town, address } = this.formData
      // return `${province} ${city} ${county} ${town} ${address}`
      return `${address}`
    }
  },
  created() {
    this.recycleNo = this.$route.query.recycleNo
    this.getPageDetDataFun()
  },
  methods: {
    // 获取页面详情数据
    getPageDetDataFun() {
      const url = `/autoapp-default-server-recovery/api/jd/recycle/getDetail/${this.recycleNo}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          const stationDtoList = res.data.stationDtoList || []
          const detailList = res.data.detailList || []
          const jdOldMachineRecycleDto = res.data.jdOldMachineRecycleDto
          const jdRecycleAnnexList = res.data.jdRecycleAnnexList || []
          // 交割单照片(1到5张)
          const waybillPhotoList = jdRecycleAnnexList.filter(item => item.annexType == 100)
          // 装车照片只有1张
          const cargoLoadingPhotoList = jdRecycleAnnexList.filter(item => item.annexType == 101)
          this.formData = Object.assign({}, this.formData, jdOldMachineRecycleDto, { waybillPhotoList, cargoLoadingPhotoList })
          this.originData = { ...Object.assign({}, this.originData, jdOldMachineRecycleDto, { waybillPhotoList, cargoLoadingPhotoList }) }
          this.recycleTableData = detailList
          this.stationDtoList = stationDtoList.map(item => ({
            ...item,
            _contactMobileVisible: false,
            _addressVisible: false,
            _contactMobileDesensitization: null,
            _addressDesensitization: null
          }))
          this.originStationDtoList = stationDtoList ? JSON.parse(JSON.stringify(stationDtoList)) : {}

          if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
            const phoneMappings = {
              signInAddress_address: 'signInAddress',
              recoveryWorkerPhone_phone: 'recoveryWorkerPhone'
            }

            // 处理非网点的脱敏数据
            res.data.desensitizationDtoList.forEach(item => {
              const targetProperty = phoneMappings[item.sensitizationCode]
              if (targetProperty) {
                this[targetProperty] = {
                  sensitizationCode: item.sensitizationCode,
                  message: item.message
                }
              }
            })

            // 处理网点的脱敏数据 - 按顺序分配给每个网点
            const contactMobileMessages = []
            const addressMessages = []

            res.data.desensitizationDtoList.forEach(item => {
              if (item.sensitizationCode === 'stationDtoContactMobile_phone') {
                contactMobileMessages.push({
                  sensitizationCode: item.sensitizationCode,
                  message: item.message
                })
              } else if (item.sensitizationCode === 'stationDtoAddress_address') {
                addressMessages.push({
                  sensitizationCode: item.sensitizationCode,
                  message: item.message
                })
              }
            })

            // 将脱敏消息分配给对应的网点
            this.stationDtoList.forEach((item, index) => {
              if (contactMobileMessages[index]) {
                this.$set(this.stationDtoList[index], '_contactMobileDesensitization', contactMobileMessages[index])
              }
              if (addressMessages[index]) {
                this.$set(this.stationDtoList[index], '_addressDesensitization', addressMessages[index])
              }
            })
          }
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 上传照片成功(照片名称id，formData照片对象，更改属性名)
    async uploadSuccess(valName, item, propName) {
      // console.log('===valName, item, propName', valName, item, propName)
      // 更新显示
      const id = item.id
      const newList = this.formData[propName]
      for (const newItem of newList) {
        if (newItem.id == id) {
          newItem.annexId = valName
        }
      }
      const url = `/autoapp-default-server-recovery/api/jd/recycle/updateFile?id=${id}&&fileId=${valName}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('更新图片成功')
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 判断是不是pdf
    isPDF(url) {
      return url && url.endsWith('.pdf')
    },
    // 下载pdf
    downLoadPdf(url) {
      const pdfUrl = `${process.env.BASE_API}/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${url}`
      window.open(pdfUrl, '_blank')
    },
    // 详情
    rowDetailFun(rowData) {
      // console.log('===rowData===', rowData)
      const orderNo = rowData.orderNo
      const jdOldMachineRecycleDetail = rowData.jdOldMachineRecycleDetail || {}
      const categoryStr = jdOldMachineRecycleDetail.category || ''
      this.$refs.oldMachineDetDialogRef.opendDialog(orderNo, categoryStr)
    },
    oldCatoeryStrFun(rowData, propName) {
      const jdOldMachineRecycleDetail = rowData.jdOldMachineRecycleDetail || {}
      return jdOldMachineRecycleDetail[propName] || ''
    },
    transDateTimeStrFun() {
      const { appointBeginDate = '', appointEndDate = '' } = this.formData
      if (appointBeginDate && appointBeginDate != 'null' && appointEndDate && appointEndDate != 'null') {
        return `${appointBeginDate}~${appointEndDate}`
      }
      return appointBeginDate || appointEndDate || '--'
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleRowVisibility(row, field) {
      // 切换该行该字段的显示状态
      const visibleField = `_${field}Visible`
      row[visibleField] = !row[visibleField]

      // 根据字段类型处理显示逻辑
      if (field === 'contactMobile') {
        const desensitization = row._contactMobileDesensitization
        if (row[visibleField] && desensitization && desensitization.message) {
          // 获取真实数据
          this.getSourceOrigin(desensitization).then(res => {
            this.$set(row, 'contactMobile', res)
          })
        } else if (!row[visibleField]) {
          // 还原为原始脱敏数据
          const originalItem = this.originStationDtoList.find(item => item.stationId === row.stationId)
          const originalValue = originalItem ? originalItem.contactMobile : '--'
          this.$set(row, 'contactMobile', originalValue)
        }
      } else if (field === 'address') {
        const desensitization = row._addressDesensitization
        if (row[visibleField] && desensitization && desensitization.message) {
          // 获取真实数据
          this.getSourceOrigin(desensitization).then(res => {
            this.$set(row, 'address', res)
          })
        } else if (!row[visibleField]) {
          // 还原为原始脱敏数据
          const originalItem = this.originStationDtoList.find(item => item.stationId === row.stationId)
          const originalValue = originalItem ? originalItem.address : '--'
          this.$set(row, 'address', originalValue)
        }
      }
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'payeeTel':
          if (this.dataVisible.payeeTel && this.payeeTel.message) {
            this.getSourceOrigin(this.payeeTel).then(res => {
              this.$set(this.formData, 'payeeTel', res)
            })
          } else if (!this.dataVisible.payeeTel) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'payeeTel', this.originData.payeeTel)
          }
          break
        case 'recoveryWorkerPhone':
          if (this.dataVisible.recoveryWorkerPhone && this.recoveryWorkerPhone.message) {
            this.getSourceOrigin(this.recoveryWorkerPhone).then(res => {
              this.$set(this.formData, 'recoveryWorkerPhone', res)
            })
          } else if (!this.dataVisible.recoveryWorkerPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'recoveryWorkerPhone', this.originData.recoveryWorkerPhone)
          }
          break
        case 'signInAddress':
          if (this.dataVisible.signInAddress && this.signInAddress.message) {
            this.getSourceOrigin(this.signInAddress).then(res => {
              this.$set(this.formData, 'signInAddress', res)
            })
          } else if (!this.dataVisible.signInAddress) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'signInAddress', this.originData.signInAddress)
          }
          break
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.page-tit {
  font-size: 16px;
  font-weight: bold;
  margin: 12px 0px;
}
.tit-name {
  font-size: 16px;
  font-weight: bold;
  margin: 12px 0px;
}
.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
  }
  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: rgb(48, 49, 51);
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .total-price {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
  }
  .footer-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 14px;
  }
  .foot-weight {
    font-size: 14px;
    color: #606266;
  }
  .downLoadLink {
    color: #1459c0;
    cursor: pointer;
  }
}
.order-detail-wrap /deep/.el-descriptions-item__label {
  min-width: 80px;
}
.order-detail-wrap /deep/.el-descriptions-item__content {
  word-wrap: break-word;
  word-break: break-all;
}
.img-flex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/recycleOrderDetail.vue